import React, { LegacyRef, useEffect, useRef, useState } from 'react'
// import { Droppable, droppables } from '../../DragDrop'
import styles from './Calendar.module.scss';
import CalHeader from './CalHeader';
import { Checkbox } from '@carbon/react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import { selectZoomFactor } from '../../panels/Calendar/CalendarSlice';
import ChannelRow from './ChannelRow';
import DayRow from './DayRow';
import moment from 'moment';
import { formatDateTime } from '../../../helper';
import CalendarTimesRow from './CalendarTimesRow';
// import { selectNow, selectPanels } from '../../../AppSlice';
// import { PanelTypes } from '../../panels/Panels';
import { IDrawEvent, IItemsSize, ITimelineItem, TimelimeChannel } from './Timeline.model';
import TimelineMonitor from './TimelineMonitor';
import Icon from '../../Icon/Icon';

function Timeline({
    panelName,
    // droppableType,
    timelineItems,
    editMode,
    zoom,
    selectedChannel,
    channels,
    startDate,
    endDate,
    calendarSize,
    hoursBeforeDay,
    hoursAfterDay,
    submittedNow,
    timelineStatus,
    TimelineItemComponent,
    drawMode,
    drawEvent,
    dragItemdId,
    onDragItem,
    onCreateDrawEvent,
    setDrawEvent,
    setDrawMode,
    onSelectChannel,
    onSubmit,
    setDragItemId,
    onStartDateChange,
    onZoomChange,
    onClickFreespace,
    headerActions,
    channelSelections,
    selectedDrawChannelIds,
    onToggleChannelSelection,
    onEditChannel,
    onRecordChannel,
    recordDisabledChannelIds = [],
    selectionDisabledChannelIds = [],
}: {
    panelName: "recorder";
    timelineItems: ITimelineItem[];
    droppableType: "recorder";
    editMode: boolean;
    zoom: number[];
    selectedChannel: string;
    channels: TimelimeChannel[];
    startDate: string
    hoursBeforeDay: number
    hoursAfterDay: number
    endDate: string;
    calendarSize: IItemsSize;
    submittedNow: boolean;
    timelineStatus: 'idle' | 'loading' | 'failed';
    TimelineItemComponent: React.FC<any>;
    drawMode: boolean;
    drawEvent: IDrawEvent;
    dragItemdId: string;
    onDragItem: (item: { id: string, start: string, channel: string }) => void;
    onCreateDrawEvent: (item: IDrawEvent) => void;
    setDrawEvent: (val: IDrawEvent) => void;
    setDrawMode: (val: boolean) => void;
    onSelectChannel: (channelId: string) => void
    setDragItemId: (id: string) => void;
    onStartDateChange: (date: string) => void
    onSubmit: () => void
    onZoomChange: (val: number[]) => void
    onClickFreespace?: (e: React.MouseEvent<HTMLDivElement>) => void;
    headerActions?: React.ReactNode;
    channelSelections?: Record<string, boolean>;
    selectedDrawChannelIds?: string[];
    onToggleChannelSelection?: (channelId: string, checked: boolean) => void;
    onEditChannel?: (channelId: string) => void;
    onRecordChannel?: (channelId: string) => void;
    recordDisabledChannelIds?: string[];
    selectionDisabledChannelIds?: string[];
}) {
    const [rowHeight, setRowHeight] = useState(0)
    const [timelineViewportWidth, setTimelineViewportWidth] = useState(1)
    const [days, setDays] = useState([])
    // const panels = useAppSelector(selectPanels)
    // const now = useAppSelector(selectNow)
    const calendarRef = useRef<HTMLDivElement>(null);
    const timeRowRef = useRef<HTMLDivElement>(null);
    

    useEffect(() => {
        const updateTimelineViewportWidth = () => {
            const containerWidth =
                calendarRef.current?.clientWidth ||
                timeRowRef.current?.clientWidth ||
                calendarRef.current?.parentElement?.clientWidth ||
                timeRowRef.current?.parentElement?.clientWidth ||
                0;
            setTimelineViewportWidth(Math.max(containerWidth - 200, 1));
        };

        updateTimelineViewportWidth();
        window.addEventListener('resize', updateTimelineViewportWidth);
        const timeoutId = window.setTimeout(() => {
            updateTimelineViewportWidth();
            goToNow();
        }, 500);

        return () => {
            window.removeEventListener('resize', updateTimelineViewportWidth);
            window.clearTimeout(timeoutId);
        };
    }, [])

    // const calcStartPerc = () => {
    //     if (moment.utc(now).startOf("day").unix() === moment.utc(day).startOf("day").unix()) {
    //         let c = (moment.utc(moment.utc(now).local().format("YYYY-MM-DD HH:mm:ss")).unix() - moment.utc(day).startOf("day").unix()) / (60 * 60 * 24) * 100
    //         if (c > 100) return null
    //         return c
    //     }
    //     return null
    // }

    // useEffect(() => {
    //     let pos = calcStartPerc()
    //     if (pos) {
    //         dispatch(setNowPosition(pos))
    //     }
    // }, [now])

    useEffect(() => {
        switch (calendarSize) {
            case "sm":
                setRowHeight(30)
                break;
            case "normal":
                setRowHeight(45)
                break;
            case "lg":
                setRowHeight(60)
                break;
            case "xl":
                setRowHeight(80)
                break;

            default:
                break;
        }
    }, [calendarSize])

    useEffect(() => {
        calendarRef?.current?.addEventListener('scroll', handleScroll, { passive: true });
        timeRowRef?.current?.addEventListener('scroll', handleScroll, { passive: true });
        document.addEventListener('keyup', handleKeyUp, false)
        return () => {
            calendarRef?.current?.removeEventListener('scroll', handleScroll);
            timeRowRef?.current?.removeEventListener('scroll', handleScroll);
            document.removeEventListener('keyup', handleKeyUp, false)
        };
    }, [calendarRef?.current, timeRowRef?.current]);


    const handleKeyUp = event => {

        if (event.key === 'Backspace') {
            //   conlog('Backspace key pressed ✅');
        }
    };

    const goToNow = () => {
        const now = moment();
        const newStartDate = now.toISOString();
        onStartDateChange(newStartDate);

        const timelineStart = moment.utc(newStartDate).startOf('day').subtract(hoursBeforeDay, 'hours');
        const totalDurationSeconds = (24 + hoursBeforeDay + hoursAfterDay) * 60 * 60;
        const nowSeconds = moment.utc(now).diff(timelineStart, 'seconds', true);

        if (totalDurationSeconds <= 0) {
            return;
        }

        let nowPosition = (nowSeconds / totalDurationSeconds) * 100;
        nowPosition = Math.min(Math.max(nowPosition, 0), 100);

        const span = Math.max(zoom[1] - zoom[0], 1);
        let zoomStart = nowPosition - span / 2;
        zoomStart = Math.min(Math.max(zoomStart, 0), 100 - span);
        const zoomEnd = zoomStart + span;

        onZoomChange([zoomStart, zoomEnd]);
    }

    const contentWidth = timelineViewportWidth / Math.max((zoom[1] - zoom[0]) / 100, 0.01)

    useEffect(() => {
        const width = contentWidth
        const position = zoom[0] * width / 100
        calendarRef?.current?.scrollTo({ "left": position })
        timeRowRef?.current?.scrollTo({ "left": position })
    }, [contentWidth, zoom, selectedChannel, channels]);

    const handleScroll = () => {
        const position = calendarRef?.current?.scrollLeft;
        // dispatch(setScrollPosition(position))
    };

    useEffect(() => {

        let start = moment.utc(startDate).unix()
        let end = moment.utc(endDate).unix()

        // if(end > start){
        //     dispatch(setEndDate(moment.unix(start).add(20, 'day').startOf('day').toISOString()))
        // }else{
        let tdays = []
        let count = 0
        do {
            tdays.push(moment.unix(start).utc().add(count, 'day').startOf('day').toISOString())
            count++;
        } while (count < 30);

        setDays(tdays)

    }, [startDate, endDate])

    return <div className={styles.calendar} >
        <div>
            <CalHeader
                channels={channels}
                zoom={zoom}
                selectedChannel={selectedChannel}
                rowHeight={rowHeight}
                startDate={startDate}
                hoursBeforeDay={hoursBeforeDay}
                hoursAfterDay={hoursAfterDay}
                goToNow={goToNow}
                onSelectChannel={onSelectChannel}
                onZoomChange={onZoomChange}
                onStartDateChange={onStartDateChange}
                onSubmit={onSubmit}
                submittedNow={submittedNow}
                timelineStatus={timelineStatus}
                headerActions={headerActions}
            />
        </div>
        {/* <Droppable type={droppableType}> */}
            <>
                <div  >
                    <div className={styles.calendarDays} >
                        <div className={styles.content} ref={timeRowRef}>
                            <div className={styles.dayRow}>
                                <div className={styles.dayContent} style={{ width: `${contentWidth}px` }} >
                                    <CalendarTimesRow
                                        hoursAfterDay={hoursAfterDay}
                                        hoursBeforeDay={hoursBeforeDay}
                                        zoom={zoom}
                                        selectedChannel={selectedChannel}
                                        onZoomChange={onZoomChange}
                                        backgroundColor="black"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ overflow: 'auto', maxHeight: "calc(100vh - 205px)" }}>
                        {selectedChannel === "" || selectedChannel === "ACTIVE" ?
                            <div className={styles.calendarDays} >
                                <div className={styles.content} ref={calendarRef}>
                                    {channels.map((channel, i) => (
                                        <ChannelRow
                                            key={`ChannelRow_${panelName}_${channel.id}_${i}`}
                                            panelName={"recording"}
                                            day={days[0]}
                                            channel={channel}
                                            items={timelineItems}
                                            index={i}
                                            editMode={editMode}
                                            rowHeight={rowHeight}
                                            selecedChannel={selectedChannel}
                                            contentWidth={contentWidth}
                                            zoom={zoom}
                                            drawMode={drawMode}
                                            setDrawMode={setDrawMode}
                                            hoursAfterDay={hoursAfterDay}
                                            hoursBeforeDay={hoursBeforeDay}
                                            TimelineItemComponent={TimelineItemComponent}
                                            drawEvent={drawEvent}
                                            setDrawEvent={setDrawEvent}
                                            onClickFreespace={onClickFreespace}
                                            onDragItem={onDragItem}
                                            dragItemdId={dragItemdId}
                                            onCreateDrawEvent={onCreateDrawEvent}
                                            setDragItemId={setDragItemId}
                                            selectedDrawChannelIds={selectedDrawChannelIds}
                                        />
                                    ))}
                                </div>
                                <div className={styles.titles}>
                                    {/* <div className={styles.title} style={{ position: 'relative', backgroundColor: '#333' }}>  </div> */}
                                    {channels.map((channel, i) => (
                                        <div key={`ChannelRow_title_${panelName}_${channel.id}_${i}`} className={styles.title} style={{ height: rowHeight, position: "relative" }} onDoubleClick={e => onSelectChannel(channel.id)}>
                                            {onToggleChannelSelection ? (
                                                <div
                                                    style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 2 }}
                                                    onClick={(event) => event.stopPropagation()}
                                                    onDoubleClick={(event) => event.stopPropagation()}
                                                >
                                                    <Checkbox
                                                        id={`timeline-channel-checkbox-${channel.id}`}
                                                        labelText=""
                                                        checked={channelSelections?.[channel.id] ?? false}
                                                        disabled={selectionDisabledChannelIds.includes(channel.id)}
                                                        onChange={(_, { checked }) => onToggleChannelSelection(channel.id, Boolean(checked))}
                                                    />
                                                </div>
                                            ) : null}
                                            <div style={{ width: 100, height: rowHeight, position: "absolute", right: 0, bottom: 0 }}>
                                                {channel?.monitorPreviewURL ? <TimelineMonitor src={channel.monitorPreviewURL} type={channel.monitorPreviewType} /> : null}
                                            </div>

                                            <div style={{ marginLeft: onToggleChannelSelection ? 28 : 0, display: 'flex', alignItems: 'center', gap: 4, width: 150, opacity: selectionDisabledChannelIds.includes(channel.id) ? 0.6 : 1 }}>
                                                {onRecordChannel && (
                                                    <button
                                                        type="button"
                                                        title="Record now"
                                                        disabled={recordDisabledChannelIds.includes(channel.id)}
                                                        onClick={(e) => { e.stopPropagation(); onRecordChannel(channel.id); }}
                                                        style={{
                                                            background: recordDisabledChannelIds.includes(channel.id) ? 'transparent' : 'rgba(218,30,40,0.12)',
                                                            border: `1px solid ${recordDisabledChannelIds.includes(channel.id) ? '#555' : '#da1e28'}`,
                                                            borderRadius: 4,
                                                            cursor: recordDisabledChannelIds.includes(channel.id) ? 'not-allowed' : 'pointer',
                                                            padding: '4px 8px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            flexShrink: 0,
                                                            opacity: recordDisabledChannelIds.includes(channel.id) ? 0.4 : 1,
                                                            zIndex: 2,
                                                        }}
                                                    >
                                                        <Icon type="circle" color={recordDisabledChannelIds.includes(channel.id) ? '#888' : '#da1e28'} size={16} />
                                                    </button>
                                                )}
                                                <div style={{ flex: 1, fontSize: 5 + (rowHeight / 5), overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{channel.title}</div>
                                                {onEditChannel && (
                                                    <button
                                                        type="button"
                                                        title="Edit slot"
                                                        onClick={(e) => { e.stopPropagation(); onEditChannel(channel.id); }}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, display: 'flex', alignItems: 'center', flexShrink: 0, zIndex: 2 }}
                                                    >
                                                        <Icon type="settings" color="#8d8d8d" size={14} />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            : <div className={styles.calendarDays} style={{ height: `calc( 100% - 50px)` }}>
                                <div className={styles.content} ref={calendarRef}>
                                    {/* <div className={styles.dayRow}>
                                        <div className={styles.dayContent} style={{ width: `${contentWidth}px` }}>
                                            <CalendarTimesRow backgroundColor="black" />
                                        </div>
                                    </div> */}
                                    {days.map((day, i) => (
                                        <DayRow
                                            key={`DayRow_${panelName}_${day + i.toString()}`}
                                            panelName={"recording"}
                                            items={timelineItems}
                                            index={i}
                                            editMode={editMode}
                                            day={day}
                                            rowHeight={rowHeight}
                                            selecedChannel={selectedChannel}
                                            contentWidth={contentWidth}
                                            zoom={zoom}
                                            drawMode={drawMode}
                                            setDrawMode={setDrawMode}
                                            TimelineItemComponent={TimelineItemComponent}
                                            drawEvent={drawEvent}
                                            setDrawEvent={setDrawEvent}
                                            onClickFreespace={onClickFreespace}
                                            onDragItem={onDragItem}
                                            dragItemdId={dragItemdId}
                                            onCreateDrawEvent={onCreateDrawEvent}
                                            setDragItemId={setDragItemId}
                                            selectedDrawChannelIds={selectedDrawChannelIds}
                                        />
                                    ))}
                                </div>
                                <div className={styles.titles}>
                                    {/* <div className={styles.title} style={{ position: 'relative', backgroundColor: '#333' }}>  </div> */}
                                    {days.map((day, i) => (
                                        <div key={"day_"+i} className={styles.title} style={moment.utc(day).startOf('day').valueOf() === moment().utc().startOf('day').valueOf() ? { backgroundColor: '#2F4152', height: rowHeight } : { height: rowHeight }} title={moment.utc(day).format('dddd - DD.MM.YYYY')}>
                                            <table width="150px">
                                                <tr >
                                                    <td width="50%" style={{ fontSize: 5 + (rowHeight / 7) }}>{moment.utc(day).format('dddd')}</td>
                                                    <td className={styles.footer}>{formatDateTime(day, 'DD.MM.YYYY')}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                    </div>
                </div>
            </>
        {/* </Droppable> */}
    </div>
}

export default Timeline
